const config = {
    APP_SERVER: process.env.VUE_APP_SERVER,
    M1_SERVER: process.env.VUE_APP_M1_SERVER,
}
export default config;
